import { Observable } from 'rxjs';
import { ResourceData } from '../models/resource-data';
import { LiveForm } from '../models/liveform';
import { SAVE_FORM_RESULT } from '../models/save-form-result.enum';

export abstract class IFormsProvider<T> {
  abstract saveForm(form: LiveForm, message?: string): Observable<SAVE_FORM_RESULT>;
  abstract saveFormResource(data: ResourceData): Promise<void>;
  abstract loadForm(formId?: string): Observable<T>;
  abstract loadFormForEdit(forced: boolean): Observable<T>;
  abstract loadFormResource(name: string, formId?: string, projectId?: string): Observable<Blob>;

  abstract deleteOfflineFormResourceByFileId(fileId: string): void;
}
